/* eslint-disable indent */
import { html, LitElement } from 'lit';
import { customElement, state, property, query } from 'lit/decorators.js';
import { translate } from '../../helpers/translate.js';
import '../shared/sdb-dialog.js';
import './sdb-elearning-select.js';
@customElement('sdb-elearning-select-dialog')
class SdbElearningSelectDialog extends LitElement {

    @state()
    accessor selectedValue = null;

    @query('#select_el_dialog')
    accessor selectElearningDialog;



    @property({type: String})
    accessor launchId = null;

    constructor() {
        super();
        this.sender = null;
        this._boundOpenDialog = this._openDialog.bind(this);
    }

    connectedCallback() {
        super.connectedCallback();
        document.addEventListener('openElearningSelectDialog', this._boundOpenDialog);
    }

    disconnectedCallback() {
        super.disconnectedCallback();
        document.removeEventListener('openElearningSelectDialog', this._boundOpenDialog);
    }

    render() {
        return html`
            <sdb-dialog
                type="form"
                id="select_el_dialog"
                heading=${translate('chooseElearning')}
                confirmCaption=${translate('select')}
                ?confirmDisabled=${this.selectedValue === null}
                @confirm=${() => { this._confirm(); }}
                @cancel=${() => { this._reset(false); }}
                .bodyRenderer=${() => html`
                    <sdb-elearning-select
                        .value=${this.selectedValue}
                        launchId=${this.launchId}
                        @selected=${(e) => { this._onSelected(e); }}>
                    </sdb-elearning-select>
                `}>
            </sdb-dialog>
        `;
    }

    async _openDialog(e) {

        this.sender = e.detail.sender;
        this.launchId = e.detail.launchId;
        await this.selectElearningDialog?.open();
    }

    _confirm() {
        this.dispatchEvent(new CustomEvent('elearningSelected', {
            detail: {
                elearning: this.selectedValue,
                sender: this.sender,
            },
            composed: true,
            bubbles: true,
        }));

        this._reset(true);
    }

    _onSelected(e) {
        this.selectedValue = e.detail.value;
    }

    _reset(skipClose = false) {
        this.selectedValue = null;
        this.launchId = null;
        if (!skipClose) {
            this.selectElearningDialog?.close();
        }
    }
}


